import React from 'react'

const Feature = () => {
  return (
    <div class="container-fluid overflow-hidden py-5 px-lg-0">
    <div class="container feature py-5 px-lg-0">
        <div class="row g-5 mx-lg-0">
        <div class="col-lg-6 feature-text wow fadeInUp" data-wow-delay="0.1s">
    <h6 class="text-secondary text-uppercase mb-3">Our Features</h6>
    <h1 class="mb-5">Providing Reliable Industrial Solutions Since 2021</h1>
    <div class="d-flex mb-5 wow fadeInUp" data-wow-delay="0.3s">
        <i class="fa fa-cogs text-primary fa-3x flex-shrink-0"></i>
        <div class="ms-4">
            <h5>High-Quality Equipment</h5>
            <p class="mb-0">We offer premium-grade industrial tools and equipment to ensure maximum efficiency and durability in operations.</p>
        </div>
    </div>
    <div class="d-flex mb-5 wow fadeIn" data-wow-delay="0.5s">
        <i class="fa fa-tools text-primary fa-3x flex-shrink-0"></i>
        <div class="ms-4">
            <h5>Comprehensive Solutions</h5>
            <p class="mb-0">From lubrication systems to pneumatic and hydraulic tools, we provide complete solutions tailored to industrial needs.</p>
        </div>
    </div>
    <div class="d-flex mb-0 wow fadeInUp" data-wow-delay="0.7s">
        <i class="fa fa-headset text-primary fa-3x flex-shrink-0"></i>
        <div class="ms-4">
            <h5>24/7 Customer Support</h5>
            <p class="mb-0">Our expert support team is available round the clock to assist you with product inquiries and technical support.</p>
        </div>
    </div>
</div>
            <div class="col-lg-6 pe-lg-0 wow fadeInRight" data-wow-delay="0.1s" >
            {/* style="min-height: 400px;" */}
                <div class="position-relative h-100">
                    <img class="position-absolute img-fluid w-100 h-100" src="img/feature.jpg"  alt="" />
                    {/* style="object-fit: cover;" */}
                </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Feature